import {
  PageBlueprint,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';

export const scaffolderPageOverride = PageBlueprint.makeWithOverrides({
  inputs: {
    formFields: createExtensionInput([
      FormFieldBlueprint.dataRefs.formFieldLoader,
    ]),
  },
  factory(originalFactory) {
    return originalFactory({
      routeRef: scaffolderPlugin.routes.root,
      path: '/create',
      title: 'Workflows',
      icon: <BusinessCenterIcon fontSize="inherit" />,
    });
  },
});
